import axios from "axios";
import env from "./env";
// import qs from "qs";
import router from "../router";
import {
  Toast
} from "vant";

axios.defaults.timeout = 10 * 1000;
// 配置cookie
axios.defaults.withCredentials = false;
// 配置请求头
// axios.defaults.headers.common["Authorization"] = store.getters.token;
// 配置接口地址
axios.defaults.baseURL = env.baseURL;
// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    // loading
    Toast.loading({
      message: "加载中...",
      duration: 0,
      forbidClick: true,
      loadingType: "spinner"
    });
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

function remove() {
  localStorage.removeItem("token");
}
axios.interceptors.response.use(
  response => {
    Toast.clear();
    return response;
  },
  error => {
    Toast.clear();
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.Message = "请求错误(400)";
          break;
        case 401:
          // remove();
          // router.push("/login");
          break;
        case 403:
          err.Message = "拒绝访问(403)";
          break;
        case 404:
          err.Message = "请求出错(404)";
          break;
        case 408:
          err.Message = "请求超时(408)";
          break;
        case 500:
          err.Message = "服务器错误(500)";
          break;
        case 501:
          err.Message = "服务未实现(501)";
          break;
        case 502:
          err.Message = "网络错误(502)";
          break;
        case 503:
          err.Message = "服务不可用(503)";
          break;
        case 504:
          err.Message = "网络超时(504)";
          break;
        case 505:
          err.Message = "HTTP版本不受支持(505)";
          break;
        default:
          err.Message = `连接出错(${err.response.status})!`;
      }
    } else {
      err.Message = "连接服务器失败!";
    }
    Toast(err.Message);
    return Promise.reject(error);
  }
);

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
export function dlt(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}



// WEBPACK FOOTER //
// ./src/http/http.js